import React, { useState, useEffect } from 'react';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import axios from 'axios';
import PropTypes from "prop-types";
import { Table, Badge, Button, Modal, Form, Pagination } from 'react-bootstrap';
import AddDiesel from './PopUps/Add/AddDiesel';
import EditDiesel from './PopUps/Edit/EditDiesel';
import * as Icon from 'react-feather';
import { canPageAction } from '../../config/roleConfig';
import DeactivateConfirmModal from '../Common/DeactivateConfirmModal';

function NewDiesel(props)  {
    const authHeader = useAuthHeader();
    const authUser = useAuthUser();
    const currentUser = authUser();
    const canRead = canPageAction(currentUser, 'finance.diesel', 'read');
    const canWrite = canPageAction(currentUser, 'finance.diesel', 'write');
    const canDelete = canPageAction(currentUser, 'finance.diesel', 'delete');

    const [data, setData] = useState([]);
    const [inventoryOptions, setInventoryOptions] = useState([]);
    const [selectedInventoryId, setSelectedInventoryId] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10); // Number of items to show per page
    const [expandedDiesel, setExpandedDiesel] = useState(null);
    const [dieselToDeactivate, setDieselToDeactivate] = useState(null);
    const [deactivatingDiesel, setDeactivatingDiesel] = useState(false);
    const apiUrl = process.env.REACT_APP_URL;

    const get_all_data = (inventoryId = '') => {
        let url = apiUrl + '/finance/diesel';
        if (inventoryId) {
            url += `?inventory_id=${inventoryId}`;
        }

        axios({
            method:'GET',
            url: url,
            headers: {
                Authorization: authHeader()
            },
        }).then(response => {
            setData(response.data.msg.Diesel);
        })
        .catch(error => {
            alert(error);
        });
    }

    const get_inventory_options = () => {
        axios({
            method: 'GET',
            url: apiUrl + '/units/get_all_units',
            headers: {
                Authorization: authHeader()
            },
        }).then(response => {
            setInventoryOptions(response.data.msg.Units);
        })
        .catch(error => {
            console.error('Error fetching inventory options:', error);
        });
    }

    useEffect(() => {
        get_inventory_options();
    }, []);

    useEffect(() => {
        if (inventoryOptions.length > 0) {
            const firstUnitId = inventoryOptions[0].id;
            setSelectedInventoryId(firstUnitId);
            get_all_data(firstUnitId);
        }
    }, [inventoryOptions]);

    const handleInventoryChange = (e) => {
        const inventoryId = e.target.value;
        setSelectedInventoryId(inventoryId);
        setCurrentPage(1); // Reset to first page when changing inventory
        get_all_data(inventoryId);
    };

    // Calculate pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(data.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const toggleDieselDetails = (dieselId) => {
        setExpandedDiesel(expandedDiesel === dieselId ? null : dieselId);
    };

    const deleteDiesel = (diesel) => {
        if (!diesel) {
            return;
        }

        setDeactivatingDiesel(true);
        axios({
            method: 'DELETE',
            url: apiUrl + '/finance/diesel',
            headers: {
                Authorization: authHeader()
            },
            data: { id: diesel.id }
        }).then(() => {
            setDieselToDeactivate(null);
            get_all_data(selectedInventoryId);
        }).catch(error => {
            alert(error.response?.data?.error || 'No se pudo desactivar la carga de diesel');
            console.log(error);
        }).finally(() => {
            setDeactivatingDiesel(false);
        });
    };

    // Generate pagination items
    const getPaginationItems = () => {
        const items = [];
        const maxVisible = 5; // Maximum number of visible page buttons

        // Always show first page
        if (totalPages > 1) {
            items.push(
                <Pagination.Item
                    key={1}
                    active={1 === currentPage}
                    onClick={() => handlePageChange(1)}
                >
                    1
                </Pagination.Item>
            );
        }

        // Show ellipsis if needed before current range
        if (currentPage > 3) {
            items.push(<Pagination.Ellipsis key="start-ellipsis" />);
        }

        // Show pages around current page
        const startPage = Math.max(2, currentPage - 1);
        const endPage = Math.min(totalPages - 1, currentPage + 1);

        for (let page = startPage; page <= endPage; page++) {
            if (page !== 1 && page !== totalPages) {
                items.push(
                    <Pagination.Item
                        key={page}
                        active={page === currentPage}
                        onClick={() => handlePageChange(page)}
                    >
                        {page}
                    </Pagination.Item>
                );
            }
        }

        // Show ellipsis if needed after current range
        if (currentPage < totalPages - 2) {
            items.push(<Pagination.Ellipsis key="end-ellipsis" />);
        }

        // Always show last page if more than one page
        if (totalPages > 1) {
            items.push(
                <Pagination.Item
                    key={totalPages}
                    active={totalPages === currentPage}
                    onClick={() => handlePageChange(totalPages)}
                >
                    {totalPages}
                </Pagination.Item>
            );
        }

        return items;
    };

        return (
            <>
            <div className="card mb-4">
                <div className="card-body">
                    <div className="card-header d-flex justify-content-between">
                        <h5 className="card-title">Registros</h5>
                        {canWrite && <AddDiesel setData={() => get_all_data(selectedInventoryId)}/>}
                    </div>

                    <div className="mb-3 d-flex align-items-center">
                        <Form.Group className="d-flex align-items-center">
                            <Form.Label className="me-2 mb-0" style={{whiteSpace: 'nowrap'}}>Filtrar por Unidad:</Form.Label>
                            <Form.Select
                                value={selectedInventoryId}
                                onChange={handleInventoryChange}
                                style={{width: '250px'}}
                            >
                                {inventoryOptions.map(inventory => (
                                    <option key={inventory.id} value={inventory.id}>
                                        {inventory.inventory_name || inventory.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </div>

                    {/* <div className="height-310"> */}
                    <div>
                        <Table className="m-0" responsive>
                            <thead>
                                <tr>
                                    <th>Unidad</th>
                                    <th>Fecha de Carga</th>
                                    <th>Litros</th>
                                    <th>KM al cargar</th>
                                    <th>Total</th>
                                    <th>Rendimiento</th>
                                    <th>Folio Fiscal Factura</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.map(diesel => (
                                    <React.Fragment key={diesel.id}>
                                        <tr>
                                            <td>{diesel.inventory_name}</td>
                                            <td>{diesel.date_loaded}</td>
                                            <td>{diesel.liters} lts</td>
                                            <td>{diesel.kilometers} km</td>
                                            <td>${diesel.total}</td>
                                            <td>{diesel.efficiency}</td>
                                            <td>{diesel.invoice_id}</td>
                                            <td>
                                                <div className="d-flex gap-1">
                                                    {canRead && (
                                                        <Button
                                                            size="sm"
                                                            variant="outline-primary"
                                                            onClick={() => toggleDieselDetails(diesel.id)}
                                                        >
                                                            <Icon.Eye size={14} />
                                                        </Button>
                                                    )}
                                                    {canWrite && <EditDiesel setData={() => get_all_data(selectedInventoryId)} dieselInfo={diesel}/>}
                                                    {canDelete && (
                                                        <Button
                                                            size="sm"
                                                            variant="outline-danger"
                                                            onClick={() => setDieselToDeactivate(diesel)}
                                                        >
                                                            <Icon.Trash2 size={14} />
                                                        </Button>
                                                    )}
                                                    {!canRead && !canWrite && !canDelete && (
                                                        <span className="text-muted">N/A</span>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                        {expandedDiesel === diesel.id && (
                                            <tr>
                                                <td colSpan={8}>
                                                    <div className="p-3 bg-light">
                                                        <p className="mb-1"><strong>Unidad:</strong> {diesel.inventory_name}</p>
                                                        <p className="mb-1"><strong>Litros:</strong> {diesel.liters} lts</p>
                                                        <p className="mb-1"><strong>Kilometraje:</strong> {diesel.kilometers} km</p>
                                                        <p className="mb-0"><strong>Folio Fiscal:</strong> {diesel.invoice_id || 'N/A'}</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </Table>
                    </div>

                    {/* Pagination Controls */}
                    {totalPages > 1 && (
                        <div className="d-flex justify-content-between align-items-center mt-3">
                            <div className="text-muted small">
                                Mostrando {indexOfFirstItem + 1} - {Math.min(indexOfLastItem, data.length)} de {data.length} entradas
                            </div>
                            <Pagination className="mb-0">
                                <Pagination.Prev
                                    disabled={currentPage === 1}
                                    onClick={() => handlePageChange(currentPage - 1)}
                                />
                                {getPaginationItems()}
                                <Pagination.Next
                                    disabled={currentPage === totalPages}
                                    onClick={() => handlePageChange(currentPage + 1)}
                                />
                            </Pagination>
                        </div>
                    )}
                </div>
            </div>
            <DeactivateConfirmModal
                show={Boolean(dieselToDeactivate)}
                title="Desactivar Carga de Diesel"
                itemLabel={dieselToDeactivate?.inventory_name}
                confirming={deactivatingDiesel}
                onCancel={() => !deactivatingDiesel && setDieselToDeactivate(null)}
                onConfirm={() => deleteDiesel(dieselToDeactivate)}
            />
            </>
        );

}
export default NewDiesel;
